<template>
  <div :class="['map-type-toggle', { 'map-type-toggle--bottom': placement === 'bottom' }]">
    <!-- Controles extras do mapa, alinhados à esquerda do switch (ex.: agrupar pins). -->
    <slot></slot>
    <div class="toggle-container">
      <div class="toggle-background">
        <div
          class="toggle-option left"
          :class="{ 'active': currentType === 'terrain' }"
          @click="setMapType('terrain')"
        >
          <img
            :src="currentType === 'terrain' ? mountainWhite : mountainGray"
            class="icon"
            alt="Terreno"
          />
          <span v-if="currentType === 'terrain'" class="label">Terreno</span>
        </div>
        <div
          class="toggle-option right"
          :class="{ 'active': currentType === 'satellite' }"
          @click="setMapType('satellite')"
        >
          <img
            :src="currentType === 'satellite' ? satelliteWhite : satelliteGray"
            class="icon"
            alt="Satélite"
          />
          <span v-if="currentType === 'satellite'" class="label">Satélite</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mountainWhite from '@/assets/icons/mountain-white.svg';
import mountainGray from '@/assets/icons/mountain-gray.svg';
import satelliteWhite from '@/assets/icons/sattelite-white.svg';
import satelliteGray from '@/assets/icons/sattelite-gray.svg';

export default {
  name: 'MapTypeToggle',
  props: {
    map: {
      type: Object,
      default: null
    },
    // 'top' (canto superior direito, mapa principal) ou 'bottom' (canto inferior
    // direito, usado nos forms, onde o topo já tem busca e botões).
    placement: {
      type: String,
      default: 'top'
    }
  },
  watch: {
    // Alguns mapas trocam o tipo por código (os forms abrem em satélite): o switch
    // acompanha o tipo real do mapa em vez de assumir que começa em "Terreno".
    map: {
      immediate: true,
      handler(map) {
        if (!map) return;
        this.syncFromMap();
        map.addListener('maptypeid_changed', () => this.syncFromMap());
      }
    }
  },
  data() {
    return {
      currentType: 'terrain', // 'terrain' ou 'satellite'
      mountainWhite,
      mountainGray,
      satelliteWhite,
      satelliteGray
    }
  },
  methods: {
    syncFromMap() {
      const id = this.map && this.map.getMapTypeId();
      if (!id) return;
      this.currentType = id === 'hybrid' || id === 'satellite' ? 'satellite' : 'terrain';
    },
    setMapType(type) {
      this.currentType = type;

      if (this.map) {
        if (type === 'terrain') {
          this.map.setMapTypeId('roadmap'); // Mapa padrão com ruas
        } else {
          this.map.setMapTypeId('hybrid'); // Satélite com ruas
        }
      }

      this.$emit('type-changed', type);
    }
  }
}
</script>

<style scoped>
.map-type-toggle {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 500;
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-container {
  cursor: pointer;
  pointer-events: all;
}

.toggle-background {
  display: flex;
  background: white;
  border-radius: 30px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.toggle-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 26px;
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 40px;
  justify-content: center;
}

.toggle-option.active {
  background: #78a64e;
  color: white;
  padding: 8px 16px;
}

.toggle-option:not(.active) {
  background: white;
  color: #999;
}

.toggle-option .icon {
  width: 20px;
  height: 20px;
}

.toggle-option .label {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.toggle-container:hover .toggle-background {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.map-type-toggle--bottom {
  top: auto;
  left: auto;
  bottom: 10px;
  right: 10px;
}

/* Responsivo para mobile */
@media (max-width: 767px) {
  .map-type-toggle:not(.map-type-toggle--bottom) {
    top: 52px;
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    bottom: auto;
  }

  .toggle-background {
    min-width: 120px;
  }

  .toggle-option {
    padding: 6px 10px;
  }

  .toggle-option .icon {
    width: 16px;
    height: 16px;
  }

  .toggle-option .label {
    font-size: 11px;
  }
}
</style>
